import { ProductComponent } from "./ProductComponent";
import SubLayout from "../common/subLayout";

const Products = (): JSX.Element => {
  return (
    <SubLayout
      _style2="my-20"
      subText="At the heart of our operations lies a dedication to recycling excellence. We leverage cutting-edge technologies to sort, process, and recycle materials, reducing the strain on natural resources"
      text="Our Products"
    >
      <ProductComponent />
      
      {/* Additional CTA Section for Products - Uses existing WhatsApp */}
      <div className="container mx-auto px-4 max-w-6xl mt-8">
        <div className="bg-gradient-to-r from-green-600 to-blue-600 rounded-2xl p-6 md:p-8 text-white text-center shadow-xl">
          <h3 className="text-xl md:text-2xl font-bold mb-2">Need Custom Orders or Bulk Pricing?</h3>
          <p className="mb-4 opacity-90 text-sm md:text-base">We offer custom manufacturing solutions and bulk discounts for large orders.</p>
          <p className="text-sm opacity-80">Contact us via WhatsApp or phone for custom orders</p>
        </div>
      </div>
    </SubLayout>
  );
};

export default Products;